module.exports = __webpack_public_path__ + "static/media/sf-test-5.b711327a.mp3";